<div class="card exception-panel">
  <div><img src="assets/images/404.jpg" class="image_404" /></div>
  <i class="material-icons warning_icon">&#xE001;</i>
  <h1 class="text">Page Not Found</h1>
  <div class="exception-detail" class="text">The resource you are looking for does not exist.</div>
</div>
